import * as React from "react"
import { Flex } from "@chakra-ui/react"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"
import { SkeletonProps } from "./skeleton.intarface"
import { FaPlay } from "react-icons/fa"
import styled from "@emotion/styled"
import type { RoomBranding } from "../../../recoil/atoms/room/types"

export interface StylesProps {
  roomStyles?: RoomBranding
  showLeaveOverlay?: boolean
}

const PlayIcon = styled(FaPlay)<StylesProps>`
  color: white;
`

export const VideoSkeleton: React.FC<SkeletonProps> = ({
  containerProps,
  offFade,
  isSmallView
}): JSX.Element => {
  const roomStyles = useRecoilValue(brandingSelector)
  return (
    <Flex
      padding="0.5rem"
      border="2px solid"
      borderRadius="0.5rem"
      width={isSmallView && "100%"}
      borderColor={roomStyles?.servicePanelElementBorder ?? "#E2E8F0"}
      background={roomStyles?.servicePanelElementBackground ?? "white"}
      style={{ ...containerProps }}
    >
      <Flex
        marginTop="auto"
        marginBottom="auto"
        height={isSmallView ? "55px" : "65px"}
        width={isSmallView ? "80px" : "100px"}
        backgroundColor={"#687786"}
      />
      <Flex flexDirection="column" marginLeft="18px" width="100%">
        <Flex
          height="8px"
          width="75px"
          backgroundColor={"#687786"}
          marginTop={isSmallView ? "5px" : "10px"}
          marginBottom="10px"
        />
        {/* <Skeleton
          height="8px"
          width="150px"
          startColor={roomStyles?.servicePanelElementPrimaryText ?? "gray.500"}
          endColor={
            offFade
              ? roomStyles?.servicePanelElementPrimaryText ?? "#E2E8F0"
              : "white"
          }
          marginBottom={!isSmallView && "10px"}
        /> */}

        <Flex height="8px" width="150px" backgroundColor={"#687786"} />

        <Flex marginTop={isSmallView ? "8px" : "18px"} alignItems="center">
          {/* <Skeleton
            height="8px"
            width="60px"
            startColor={
              roomStyles?.servicePanelElementPrimaryText ?? "gray.500"
            }
            endColor={
              offFade
                ? roomStyles?.servicePanelElementPrimaryText ?? "#E2E8F0"
                : "white"
            }
          /> */}
          <Flex
            height={isSmallView ? "28px" : "32px"}
            paddingLeft={isSmallView && "5px"}
            borderRadius="0.375rem"
            justifyContent="center"
            alignItems="center"
            width="50px"
            marginLeft="auto"
            backgroundColor={"#687786"}
            color="white"

            /*  endColor={
              offFade
                ? roomStyles?.servicePanelElementPrimaryText ?? "#E2E8F0"
                : "white"
            } */
          >
            <PlayIcon />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}
